const ApiURL = {
    accountList: "account-list",
    login: "/player-login",
    getProviderList: "/get-providers",
    getGameList: "/get-gamelist",
    getGameUrl: "/get-game-url",
    getCategories: "/get-categories",
    getGames: "/get-games",
    getPlayerBalance: "/get-player-balance",
    parentProviderList: "/parent-provider-list",
    subProviderList: "/sub-provider-list",
    getFilterProviders: "/get-filter-providers",
    getFilterGames:"/get-filter-games",
    getAggregators: "/get-aggregators"
}

export default ApiURL;
